var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-modal',{attrs:{"hide-secondary-button":true,"primary-button-label":"Editar periodo","modal-title":"Editar periodo"},on:{"closeModal":_vm.onCloseModal,"primaryButtonClick":_vm.onSave}},[_c('div',{staticClass:"content"},[_c('periods-form',{ref:"form",attrs:{"old":_vm.oldPeriod}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf3c45f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/periods/periods-edit-view.vue
// module id = null
// module chunks = 